import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { symbol as Symbol } from '@wix/santa-editor-symbols';

export default {
  Fold: () => <Symbol name="motion-ongoing-fold" />,
  Bounce: () => <Symbol name="motion-ongoing-bounce" />,
  Poke: () => <Symbol name="motion-ongoing-poke" />,
  Swing: () => <Symbol name="motion-ongoing-swing" />,
  Flash: () => <Symbol name="motion-ongoing-flash" />,
  Rubber: () => <Symbol name="motion-ongoing-rubber" />,
  Breathe: () => <Symbol name="motion-ongoing-breathe" />,
  Wiggle: () => <Symbol name="motion-ongoing-wiggle" />,
  Jello: () => <Symbol name="motion-ongoing-jello" />,
  Spin: () => <Symbol name="motion-ongoing-spin" />,
  Cross: () => <Symbol name="motion-ongoing-cross" />,
  Flip: () => <Symbol name="motion-ongoing-flip" />,
  Pulse: () => <Symbol name="motion-ongoing-pulse" />,
};
